import React from "react";
import { SectionDivider, Container, Title } from './WorkStyles'
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import 'react-vertical-timeline-component/style.min.css'
import novaxLogo from '../Novax Logo.png'
import bbbLogo from '../Bed Bath Logo.png'
import pentagonLogo from '../Pentagon Logo.jpg'

const Work = () => (
    <div id="work">
        <SectionDivider />
        <Container>
            <Title>Work Experience</Title>
            <br />
            <div className='mt-20 flex flex-col'>
                <VerticalTimeline>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: '#112448', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid #fff' }}
                    icon={<img src={novaxLogo} alt="Novax" style={{maxWidth: '100%'}}  />}
                    iconStyle={{ background: '#112448', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">Software Developer Co-op</h3>
                    <h4 className="vertical-timeline-element-subtitle" style={{color: 'orange'}}>Novax Industries Corporation</h4>
                    <p>
                    Description of your work experience
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: '#112448', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid #fff' }}
                    icon={<img src={novaxLogo} alt="Novax" style={{maxWidth: '100%'}}  />}
                    iconStyle={{ background: '#112448', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">Electrical Engineering Co-op</h3>
                    <h4 className="vertical-timeline-element-subtitle" style={{color: 'orange'}}>Novax Industries Corporation</h4>
                    <p>
                    Description of your work experience
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: '#112448', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid #fff' }}
                    icon={<img src={bbbLogo} alt="BedBath" style={{maxWidth: '100%', borderRadius: '50%'}}  />}
                    iconStyle={{ background: '#112448', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">Sales Associate</h3>
                    <h4 className="vertical-timeline-element-subtitle" style={{color: 'orange'}}>Bed Bath and Beyond</h4>
                    <p>
                    Description of your work experience
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: '#112448', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid #fff' }}
                    icon={<img src={pentagonLogo} alt="Pentagon" style={{maxWidth: '100%', borderRadius: '50%'}}  />}
                    iconStyle={{ background: '#112448', color: '#fff' }}
                >
                    <h3 className="vertical-timeline-element-title">Manufacturing Engineering Intern</h3>
                    <h4 className="vertical-timeline-element-subtitle" style={{color: 'orange'}}>Pentagon Rubber Ltd.</h4>
                    <p>
                    Description of your work experience
                    </p>
                </VerticalTimelineElement>
                
                </VerticalTimeline>
            </div>
        </Container>
    </div>
);

export default Work;